import { TemplateConfig } from '../../template-config.interface';

export const disneyCast: TemplateConfig = {
  id: 'cast',
  clientId: 'DISNEY',
  title: 'Elenco',
  description: 'Template para mostrar elenco',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/elenco.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/elenco.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/grandes_elencos.mp4',
  formFields: [],
  promptTemplate: ''
};
